import { Box, styled } from "@mui/material";

export const BoxContainer = styled(Box)(({ theme }) => (props) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "300px",
    backgroundColor: 'background.paper',
    boxShadow: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    direction: 'ltr',
    backgroundColor: '#fff'
}))